import ServiceBase from './ServiceBase';

export default class ProjectCategoriesService extends ServiceBase {

    createProjectCategory(projectCategory) {
        const params = {
            ...projectCategory,
        };

        return this.request('post', 'admin/projectCategories/createProjectCategory', params);
    }

    deleteProjectCategory(projectCategoryID) {
        const params = {
            projectCategoryID,
        };

        return this.request('post', 'admin/projectCategories/deleteProjectCategory', params);
    }

    searchProjectCategories(filters = {}, pageSize = null, pageIndex = null) {
        const params = {
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'admin/projectCategories/searchProjectCategories', params);
    }

    updateProjectCategory(projectCategory) {
        const params = {
            ...projectCategory,
        };

        return this.request('post', 'admin/projectCategories/updateProjectCategory', params);
    }

    isProjectCategoryNameTaken(projectCategoryID, name) {
        return this.request('get', 'admin/projectCategories/isProjectCategoryNameTaken', { params: { projectCategoryID, name } });
    }

    changeProjectCategorySortOrder(projectCategory) {
        const params = {
            ...projectCategory,
        };

        return this.request('post', 'admin/projectCategories/changeProjectCategorySortOrder', params);
    }

    getCategories() {
        return this.request('get', 'projectCategories/getCategories');
    }
}
